/**
 *
 * 검색바 컴포넌트
 *
 */
define(['jquery', 'vue', 'clone-deep', 'api-request', 'spinner'], function (
    $,
    Vue,
    cloneDeep,
    apiRequest
) {
    if (typeof window.event_bus === 'undefined')
    {
        window.event_bus = new Vue();
    }

    Vue.component('cc-search-bar', {
        delimiters: ['@{', '}@'],
        template  : "\
                <div class='cc-search-bar-container' :id='component_id'>\
                    <input type='text' class='search-bar-keyword'\
                        @click='openHelper()'\
                        @input='updateTypingKeyword'\
                        @keyup.enter='emitKeywordUpdateEvent()'\
                        placeholder='검색어를 입력해주세요'\
                        v-model='keyword'>\
                    <div class=\"cc-search-btn\" @click.stop='emitKeywordUpdateEvent()' v-html='search_btn_html'></div>\
                    \
                    <!-- 검색 도우미: 최근 검색어, 추천 태그 -->\
                    <div class='search-bar-helper' v-if=\"helper_stat=='open' && (recent_keywords.length > 0 || recommended_keywords.length > 0)\">\
                        <div class='close-helper-btn' @click='closeHelper()'>\
                            <img src='https://cconma-usa.gcdn.ntruss.com/assets/mall/ic-remove-search-keyword.png'>\
                        </div>\
                        <div class='recent-keywords-wrap' v-if='recent_keywords.length > 0'>\
                            <label>최근 검색어</label>\
                            <div class='recent-keyword-wrap' v-for='(k, i) in recent_keywords_uniq'>\
                                <div class='recent-keyword'>\
                                    <span @click='keyword=k;emitKeywordUpdateEvent()'>\
                                        @{k}@\
                                    </span>\
                                    <img src='https://cconma-usa.gcdn.ntruss.com/assets/mall/ic-remove-search-keyword.png'\
                                        @click='removeRecentKeyword(i)'>\
                                    <div style='clear:both'></div>\
                                </div>\
                            </div>\
                            <div style='clear:both'></div>\
                            <div class='remove-all-recent-keywords-btn' @click='removeAllRecentKeywords()'>\
                                검색어 전체 삭제\
                            </div>\
                            <div style='clear:both'></div>\
                        </div>\
                        <div class='recommended-keywords-wrap' v-if='recommended_keywords.length > 0'>\
                            <label>추천태그</label>\
                            <a :href='k.url' v-for='k in recommended_keywords'>\
                                <div class='recommended-keyword'>\
                                    <div class='recommended-keyword-img'>\
                                        <img :src='k.image_url'>\
                                    </div>\
                                    <div class='recommended-keyword-text' v-html='k.label'></div>\
                                </div>\
                            </a>\
                            <div style='clear:both'></div>\
                        </div>\
                        <div style='clear:both'></div>\
                    </div>\
                </div>\
            ",
        props     : [
            'container_id', // 상위 컨테이너에서 부여하는 id(상위 컨테이너가 여럿 일 수 있음). 컴포넌트 내부에서 검색어 변경 이벤트 emit시 이 id를 함께 보내야 하고, 이벤트를 받는 상위 컨테이어는 자신이 보내준 id와 일치시에만 검색 실행.
            'terms', // 키워드 초기값 (쇼피파이 기본 검색 폼 사용시 검색어가 들어가는 예약어)
            'search_btn_html' // 버튼 디자인이 CSS에서 커버 불가능할 정도로 다른 경우들 때문에 HTML을 주입받음
        ],
        data      : function () {
            return {
                component_id        : 'search-bar-' + this.container_id,
                keyword             : cloneDeep(this.terms),
                recommended_keywords: [],
                recent_keywords     : [],
                helper_stat         : 'closed' // 검색 도우미(최근 검색어, 추천 태그 등 표시) 상태 closed:닫힘, opened:열림
            }
        },
        created   : function () {
        },
        watch     : {},
        mounted   : function () {
            // latest-keywords가 recent-keywords로 변경됨에 따라 마이그레이션 처리함.
            // TODO 2021.11.1 이후 누구든 마이그레이션 코드 삭제할 것
            if (window.localStorage.getItem('latest-keywords'))
            {
                window.localStorage.setItem('recent-keywords', window.localStorage.getItem('latest-keywords'));
                window.localStorage.removeItem('latest-keywords');
            }

            this.loadRecentKeywords();
            var _this = this;

            // 모바일, 앱, 패드에서 최근 검색어 레이아웃을 기본으로 노출한다.
            // -> 최근검색어 레이아웃이 기본노출되면서 부자연스런을 화면 연출이 자주 발생한다. 따로 요청이 있을때까지 미노출로한다 by sonbohoon
            /*
            if (/iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent))
            {
                if (!this.keyword)
                {
                    require(['get-params'], function (GetParams) {
                        var max_price = new GetParams().get('max_price');
                        if (!max_price)
                        {

                             _this.openHelper();
                        }
                    });
                }
            }
            */

            // 컴포넌트 외부 클릭시 최근 검색어 레이아웃을 숨긴다.
            $("body").on("click", function (e) {
                var $component = $("#" + _this.component_id);
                // 컴포넌트 외부 클릭 여부를 판단하기 위해
                // 1. $component이 이벤트 타겟이 아니어야 함
                // 2. $component 내부의 엘리먼트를 클릭한 게 아니어야 함 ( $component.has(e.target) => $component 중 e.target 을 포함하는 것들만 필터 )
                if (!$component.is(e.target) && $component.has(e.target).length === 0)
                {
                    _this.closeHelper();
                }
            });
        },
        computed  : {
            //중복제거된 최근 검색어
            recent_keywords_uniq: function () {
                return this.recent_keywords.filter(function (x, i, a) {
                    return a.indexOf(x) === i;
                });
            }
        },
        methods   : {
            loadRecentKeywords: function () {
                this.recent_keywords = window.localStorage.getItem('recent-keywords') ? JSON.parse(window.localStorage.getItem('recent-keywords')) : [];
                if (!Array.isArray(this.recent_keywords))
                {
                    this.recent_keywords = [];
                }
            },
            /**
             * 최근검색어 삭제
             * @param idx
             */
            removeRecentKeyword: function (idx) {
                this.recent_keywords.splice(idx, 1);
                window.localStorage.setItem('recent-keywords', JSON.stringify(this.recent_keywords));
            },
            /**
             * 최근검색어 추가
             * @param {string} keyword
             */
            addRecentKeyword: function (keyword) {
                keyword = keyword.trim();
                if (!keyword)
                {
                    return;
                }
                this.recent_keywords.unshift(keyword);
                window.localStorage.setItem('recent-keywords', JSON.stringify(this.recent_keywords_uniq.slice(0, 10)));
            },
            /**
             * 모든 최근검색어 삭제
             */
            removeAllRecentKeywords: function () {
                window.localStorage.setItem('recent-keywords', "[]");
                this.recent_keywords = [];
            },
            closeHelper            : function () {
                this.helper_stat = 'closed';
            },
            openHelper             : function () {
                if (this.helper_stat !== 'open')
                {
                    this.loadRecentKeywords();
                    this.helper_stat = 'open';

                    // 추천 검색어 fetch
                    var _this = this;
                    apiRequest.get("https://cus7.cconmausa.com/api/cms-label/recommended-keywords")
                        .then(function (response) {
                            _this.recommended_keywords = response;
                        });
                }
            },
            updateTypingKeyword    : function (e) {
                if (e.keyCode === 13)
                {
                    return;
                }
                this.keyword = e.target.value;
            },
            /**
             * 검색어 송출
             */
            emitKeywordUpdateEvent: function () {
                this.closeHelper();

                // 검색 시작 시 항상 모바일 화상 키보드 숨기기
                var $keyword_input = $(".search-bar-" + this.container_id).find(".search-bar-keyword");
                $keyword_input.blur();

                var keyword = this.keyword.trim();
                this.addRecentKeyword(keyword);

                // this.id는 상위 컨테이너에서 부여하는 id(상위 컨테이너가 여럿 일 수 있음).
                // 컴포넌트 내부에서 검색어 변경 이벤트 emit시 이 id를 함께 보내야 하고, 이벤트를 받는 상위 컨테이어는 자신이 보내준 id와 일치시에만 검색 실행.
                window.event_bus.$emit("search:onKeywordUpdate", this.container_id, keyword);
            }
        }
    });
});
